<template>
    <div>
        <common-table :table-columns="tableColumns" :form-fields="formFields" :permission="permission" :url="url"
            :operate="[]" :searchs="searchs" />
    </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";
export default {
    name: "Finance",
    components: { CommonTable },
    data() {
        return {
            searchs: [{
                name: 'agentId',
                placeholder: '站点',
                type: 'select',
                selectUrl: '/agent/getAll',
                selectData: [],
            }, {
                name: 'startTime',
                placeholder: '开始时间',
                type: 'dateTime'
            }, {
                name: 'endTime',
                placeholder: '结束时间',
                type: 'dateTime'
            }],
            permission: {
                /*add: 'finance:add',
                update: 'finance:update',
                delete: 'finance:delete',
                deleteBatch: 'finance:deleteBatch'*/
            },
            url: {
                get: '/finance/listByCondition/all',
                /*add: '/finance/add',
                update: '/finance/update',
                delete: '/finance/delete/',
                delete_batch: '/finance/deleteBatch',*/
            },
            tableColumns: [{
                field: 'id',
                label: 'ID',
                show: true,
                detail: true,
                width: '',
            }, {
                field: 'agentId',
                label: '站点',
                selectUrl: '/agent/getAll',
                selectData: [],
                show: {
                    type: 'select',
                },
                detail: false,
                width: '',
            }/*, {
                  field: 'systemUserName',
                  label: '代理',
                  selectData: [],
                  show: true,
                  detail: false,
                  width: '',
                }*/, {
                field: 'publishNumber',
                label: '领取数量',
                show: true,
                width: '',
            }, {
                field: 'receiveNumber',
                label: '发布数量',
                show: true,
                width: '',
            }, {
                field: 'registerNum',
                label: '注册人数',
                show: true,
                width: '',
            }, {
                field: 'createTime',
                label: '时间',
                show: true,
                width: '',
            }, /*{
                    field: 'rechargeMoney',
                    label: '充值金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeNum',
                    label: '充值人数',
                    show: true,
                    width: '',
                }, {
                    field: 'rechargeTimes',
                    label: '充值笔数',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalMoney',
                    label: '提现金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalNum',
                    label: '提现人数',
                    show: true,
                    width: '',
                }, {
                    field: 'withdrawalTimes',
                    label: '提现笔数',
                    show: true,
                    width: '',
                },*/ /*{
                    field: 'agencyRatio',
                    label: '代理占成',
                    show: {
                        type: 'money'
                    },
                    width: '',
                }, {
                    field: 'agencyFee',
                    label: '代理费用(USDT)',
                    show: true,
                    width: '',
                },{
                    field: 'profit',
                    label: '盈利(USDT)',
                    show: true,
                    width: '',
                } */],
            formFields: {
                addTitle: '添加财务',
                updateTitle: '修改财务',
                labelWidth: '105px',
                model: [{
                    field: 'rechargeMoney',
                    label: '充值金额：',
                    type: 'money',
                    placeholder: '请输入充值金额',
                    rules: [{
                        message: '请输入充值金额', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'rechargeNum',
                    label: '充值人数：',
                    type: 'input',
                    placeholder: '请输入充值人数',
                    rules: [{
                        message: '请输入充值人数', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'rechargeTimes',
                    label: '充值笔数：',
                    type: 'input',
                    placeholder: '请输入充值笔数',
                    rules: [{
                        message: '请输入充值笔数', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'withdrawalMoney',
                    label: '提现金额：',
                    type: 'money',
                    placeholder: '请输入提现金额',
                    rules: [{
                        message: '请输入提现金额', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'withdrawalNum',
                    label: '提现人数：',
                    type: 'input',
                    placeholder: '请输入提现人数',
                    rules: [{
                        message: '请输入提现人数', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }, {
                    field: 'withdrawalTimes',
                    label: '提现笔数：',
                    type: 'input',
                    placeholder: '请输入提现笔数',
                    rules: [{
                        message: '请输入提现笔数', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }/*, {
                        field: 'agencyRatio',
                        label: '代理占成：',
                        type: 'money',
                        placeholder: '请输入代理占成',
                        rules:[{
                            message: '请输入代理占成', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'agencyFee',
                        label: '代理费用：',
                        type: 'money',
                        placeholder: '请输入代理费用',
                        rules:[{
                            message: '请输入代理费用', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }*/, {
                    field: 'profit',
                    label: '盈利：',
                    type: 'money',
                    placeholder: '请输入盈利',
                    rules: [{
                        message: '请输入盈利', trigger: 'blur', required: true
                    }],
                    add: true,
                    update: true,
                }]
            }
        }
    }
}
</script>

<style scoped></style>
